import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/dag0go3ep053ijub214g';

export default function Subscribe() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);
    // honeypot: silently drop bot submissions with the same success feedback
    const honeypot = String(formData.get('contact_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      setEmail('');
      return;
    }

    // build payload from actual form fields (exclude empty honeypot)
    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'contact_alt') return;
      payload.append(key, String(value));
    });

    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText;

      if (res.ok && code === 'OK') {
        setStatus('success');
        form.reset();
        setEmail('');
      } else {
        setStatus('error');
        setMessage(serverMsg || '订阅失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试。');
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20 bg-foreground-950 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-400/10 px-4 py-1.5 text-sm text-accent-300">
          <i className="ri-notification-3-line" />
          订阅蹲位 · 节点提醒送到你手上
        </span>
        <h2 className="mt-5 font-heading text-3xl font-black text-background-50 md:text-5xl">
          开瓜前，<span className="text-accent-400">先蹲好位置</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-background-100/70 md:text-lg">
          留下邮箱，每逢周一见、周五晚、周末大瓜、月末盘点、季度压轴临近，
          我们会第一时间推送该节点的蹲守预告，让你从容蹲瓜不慌张。
        </p>

        <form
          id="subscribe-form"
          data-readdy-form
          name="大瓜预警资讯订阅"
          onSubmit={handleSubmit}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center sm:gap-2 sm:rounded-full sm:border sm:border-background-50/15 sm:bg-background-50/10 sm:p-1.5"
        >
          <div className="relative flex-1">
            <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-background-100/60 sm:text-foreground-400" />
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              autoComplete="email"
              className="w-full rounded-full border border-background-50/20 bg-background-50/10 py-3 pl-12 pr-4 text-sm text-background-50 placeholder:text-background-100/50 outline-none transition focus:border-accent-400 sm:border-transparent sm:bg-transparent sm:py-2.5 sm:text-foreground-900 sm:placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:py-2.5"
          >
            <i className="ri-send-plane-fill" />
            立即订阅
          </button>
          <input
            type="text"
            name="contact_alt"
            aria-hidden="true"
            tabIndex={-1}
            autoComplete="off"
            readOnly
            className="hp-catch"
          />
        </form>

        <div className="mt-4 min-h-[1.5rem] text-sm" aria-live="polite">
          {status === 'success' && (
            <p className="inline-flex items-center gap-2 text-accent-300">
              <i className="ri-checkbox-circle-fill" />
              订阅成功，蹲位已锁定！我们会在节点临近时给你发提醒。
            </p>
          )}
          {status === 'error' && (
            <p className="inline-flex items-center gap-2 text-red-300">
              <i className="ri-error-warning-fill" />
              {message}
            </p>
          )}
        </div>

        <p className="text-xs text-background-100/50">
          放心，我们只用于蹲守提醒，绝不群发打扰，也可随时退订。
        </p>
      </div>
    </section>
  );
}